window.appKey ??= "kXK2MsK90GqNNn4VIRzpbuemME0g7Glc8mw8DvoR";
const starRatings = document.querySelectorAll('.ytp-bottomline');  

  //document.addEventListener('DOMContentLoaded', function() {
    $(document).ready(function() {  
        refreshBottomLine();
    });

  function refreshBottomLine() {
    starRatings.forEach(el => {
      const productId = el.getAttribute('data-productid');
      console.log('trying to get reviews product id ' + productId);
      if(productId) {
          fetchBottomline(productId);
      }
      });
  }

  async function fetchBottomline(productId) {
    const url = `https://api-cdn.yotpo.com/products/${appKey}/${productId}/bottomline`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      bottomline = data.response.bottomline;
      console.log(`bottomline: ${JSON.stringify(bottomline)}`)
      if(bottomline) {
        displayBottomline(bottomline, productId);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  }

  function displayBottomline(bottomline, productId) {
    const starRating = document.querySelectorAll(`.ytp-bottomline[data-productid="${productId}"] .ytp-star-rating`);
    const totalReviews = document.querySelectorAll(`.ytp-bottomline[data-productid="${productId}"] .ytp-total-reviews`);

    if(totalReviews) {
        totalReviews.forEach(item => {
          let totalReviewsText = bottomline.total_reviews.toLocaleString();
          /*if (productId === '7241766928482') { //supima-cotton-duvet-cover
            totalReviewsText = '18,565';
          } else if (productId === '7241017000034') { //supima-cotton-sheet-set
            totalReviewsText = '14,451';
          } else if (productId === '7241016541282') { //belgian-linen-sheet-set
            totalReviewsText = '7,894';
          } else if (productId === '7241832104034') { //belgian-linen-duvet-cover
            totalReviewsText = '10,182';
          }*/
          item.innerText = totalReviewsText;
        });
    }
    if(starRating) {
        starRating.forEach(item => {
            item.innerHTML = generateStarRating(bottomline.average_score);
        });
    }
    const avgScore = document.querySelectorAll(`.ytp-bottomline[data-productid="${productId}"] .ytp-avg-score`);
    if(avgScore) {
        avgScore.forEach(item => {
            const s = (Math.round(bottomline.average_score * 10) / 10).toFixed(1);
            item.innerText = s + ' stars';
        });
    }

    // Mirror the live count into the Product structured data, but only for the
    // page's own product — the same bottomline widget markup is also used for
    // recommended products, whose counts must not overwrite this page's schema.
    const schemaEl = document.getElementById('seo-schema-product');
    if (schemaEl && schemaEl.dataset.productId === String(productId) && window.syncProductSchema) {
      window.syncProductSchema(bottomline.total_reviews, bottomline.average_score);
    }
  }

  function generateStarRating(score) {
    let fullStars = Math.floor(score);
    let decimalPart = score - fullStars;
    let hasHalfStar = decimalPart >= 0.5;
    let totalStars = fullStars + (hasHalfStar ? 1 : 0);
    let emptyStars = 5 - totalStars;

    let starsHTML = "";

    for (let i = 0; i < fullStars; i++) {
      starsHTML += getStarSVG("full");
    }

    if (hasHalfStar) {
      starsHTML += getStarSVG("half");
    }

    for (let i = 0; i < emptyStars; i++) {
      starsHTML += getStarSVG("empty");
    }

    return starsHTML;
  }

  function getStarSVG(type) {
    let starWidth = 20;
    let starHeight = 18;
    // Default gold globally; use #2D261B only on the redesigned PDP template.
    var STAR_COLOR = document.querySelector('.pdp-redesign') ? "#2D261B" : "#F6CA51";

    if (type === "full") {
        return `<svg class="star full-star" width="${starWidth}" height="${starHeight}" viewBox="0 0 30 28" fill="${STAR_COLOR}" stroke="${STAR_COLOR}" stroke-width="1">
                    <polygon points="15,2 19,10 28,10 21,16 23,26 15,21 7,26 9,16 2,10 11,10"/>
                </svg>`;
    } else if (type === "half") {
        return `<svg class="star half-star" width="${starWidth}" height="${starHeight}" viewBox="0 0 30 28" stroke="${STAR_COLOR}" stroke-width="1">
                    <defs>
                        <linearGradient id="halfGradient">
                            <stop offset="50%" stop-color="${STAR_COLOR}"/>
                            <stop offset="50%" stop-color="transparent"/>
                        </linearGradient>
                    </defs>
                    <polygon points="15,2 19,10 28,10 21,16 23,26 15,21 7,26 9,16 2,10 11,10" fill="url(#halfGradient)"/>
                </svg>`;
    } else {
        return `<svg class="star empty-star" width="${starWidth}" height="${starHeight}" viewBox="0 0 30 28" stroke="${STAR_COLOR}" stroke-width="1" fill="transparent">
                    <polygon points="15,2 19,10 28,10 21,16 23,26 15,21 7,26 9,16 2,10 11,10"/>
                </svg>`;
    }
  }